<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">


        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_contain_palm" name="is_contain_palm" rules="" v-slot="{ errors }">
              <small class="label">Does this product contain any ingredients which are derived from palm (including additives, preservatives, diluents, processing aids, enzymes and solvents)?</small>
              <vs-switch v-model="form.is_contain_palm" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_contain_palm" vid="is_contain_palm_comment" name="is_contain_palm_comment" rules="" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input type="text" v-model="form.is_contain_palm_comment" name="is_contain_palm_comment" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_contain_palm">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="component_palm" name="component_palm" rules="required" v-slot="{ errors }">
              <small class="label">Component which is derived from palm?</small>
              <vs-input type="text" v-model="form.component_palm" name="component_palm" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_contain_palm">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_palm_RSPO" name="is_palm_RSPO" rules="" v-slot="{ errors }">
              <small class="label">Is the palm from an RSPO Certified source?</small>
              <vs-switch v-model="form.is_palm_RSPO" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_palm_RSPO" vid="is_palm_RSPO_comment" name="is_palm_RSPO_comment" rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input type="text" v-model="form.is_palm_RSPO_comment" name="is_palm_RSPO_comment" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_palm_RSPO && form.is_contain_palm">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="certificate_type" name="certificate_type" rules="required" v-slot="{ errors }">
              <small class="label">Certification type</small>
              <v-select  label="name" :closeOnSelect="true" multiple v-model="form.certificate_type"
                         :reduce="option => option.value"
                         :options="[{name: 'Book & Claim', value: 'book_claim'}, {name: 'Identity Preserved', value: 'identity_preserved'},
                         {name: 'Mass Balance', value: 'mass_balance'}, {name: 'Segregated', value: 'segregated'}, {name: 'None', value: 'none'}]"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
<!--            <ValidationProvider vid="RSPO_certificate" name="RSPO_certificate" :rules="fileValidation()" v-slot="{ errors }">-->
<!--              <small class="label">RSPO certificate</small>-->
<!--              <a target="_blank" v-if="form.RSPO_certificate" class="float-right" :href="form.RSPO_certificate">view file</a>-->
<!--              <vs-input style="color:transparent; width:70px;" @change="onUploadRSPOCertificate($event)" type="file" name="RSPO_certificate" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]"  />-->
<!--            </ValidationProvider>-->
            <!--            form.RSPO_certificate-->
            <small class="label">RSPO certificate</small>
            <file-uploader-not-required v-on:onSetFileName="value => form.RSPO_certificate = value" v-on:onClickFileRemove="form.RSPO_certificate = null" :file="form.RSPO_certificate" :condition="true"/>

          </div>
        </div>

        <div class="vx-row mb-3" v-if="!form.is_palm_RSPO && form.is_contain_palm">
          <div class="vx-col w-full">
            <ValidationProvider vid="not_from_RSPO" name="not_from_RSPO" rules="required" v-slot="{ errors }">
              <small class="label">If the palm is not from an RSPO certified source, please provide details on plans for certification
              </small>
              <vs-textarea class="mb-0" v-model="form.not_from_RSPO" />
              <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import FileUploader from '@/components/shared/FileUploader'
  import FileUploaderNotRequired from '@/components/shared/FileUploaderNotRequired'


  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import RawMaterialForm from "@/mixins/RawMaterialForm";

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_contain_palm: false,
          is_palm_RSPO: false,
          RSPO_certificate: ''
        },
        id: null,
        status: {}
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    components: {
      'v-select': vSelect,
      FileUploader,
      FileUploaderNotRequired,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_palm_oil_derivative_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_palm_oil_derivative_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialDerivatives(this.id, this.form))
          this.showSuccessMessage('Raw Material Derivatives Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialDerivatives(this.form))
          this.showSuccessMessage('Raw Material Derivatives Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialDerivatives(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async onUploadRSPOCertificate(event, model_name) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.RSPO_certificate = (await SupplierRepository.uploadFile(formData)).data.data.file
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      fileValidation() {
        if (!!this.form.RSPO_certificate || (this.form.certificate_type) ) {
          if (this.form.certificate_type[0] === 'none') {
            return ''
          } else if (this.form.RSPO_certificate){
            return ''
          } else {
            return 'required'
          }
        } else {
          return 'required'
        }
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_palm_oil_derivative_complete) {
        await this.loadData()
      }
    },
    watch: {
      form() {

      }
    }

  }
</script>

<style scoped>

</style>
